import React from 'react';
import { OptionType } from 'bricks/NSSelectWithCheckboxes/NSSelectWithCheckboxes';
import { IOptionNumberValue } from 'bricks/types';
import { NSInput } from 'bricks';
import ReportFilters from './ReportFilters';
import { FILTERS_PARAM_KEYS } from './constants';

export interface IReportsControlProps {
    filterSettings: Partial<Record<FILTERS_PARAM_KEYS, IOptionNumberValue[]>> | undefined;
    setFilterSettings: React.Dispatch<React.SetStateAction<Partial<Record<FILTERS_PARAM_KEYS, IOptionNumberValue[]>> | undefined>>;
    reportTypeOptions: OptionType[];
    dealOptions: OptionType[];
    searchValue: string;
    setSearchValue: React.Dispatch<React.SetStateAction<string>>;
}

const ReportsControl = ({
    filterSettings, setFilterSettings, reportTypeOptions, dealOptions, searchValue, setSearchValue,
}: IReportsControlProps) => (
    <div className="Reports-control d-flex justify-content-between my-3">
        <ReportFilters
            filterSettings={filterSettings}
            setFilterSettings={setFilterSettings}
            reportTypeOptions={reportTypeOptions}
            dealOptions={dealOptions}
        />
        <div>
            <NSInput
                customClassName="Reports-control__search-input bg-secondary text-white px-2"
                type="text"
                name="search"
                placeholder="Search"
                value={searchValue}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value)}
                inputWidth="320px"
                inputHeight="34px"
                maxLength={256}
            />
        </div>
    </div>
);

export default ReportsControl;
